import React from 'react';
import styled, { keyframes } from 'styled-components';
import PatientSlotContainer from './PatientSlotContainer';
import PatientInfo from './PatientInfo';
import BedInfo from './BedInfo';
import { INTERNAL_MONITOR, PACU_TABLET, POST_OP_TABLET, PREP_TABLET } from '../../entities/screens/enums';
import { createStyles, makeStyles } from '@material-ui/core';
import CaretakerMessage from './CaretakerMessage';
import { useIsDelayed, useIsPacuLate } from '@/components/patient/PatientSlot/PatientSlotDefault';

const emphasize = keyframes`
  0% {
    border-color: rgba(255, 172, 0, 0);
    box-shadow: 0 0 4px rgba(255, 172, 0, 0);
  }
  100% {
    border-color: rgba(255, 172, 0, 1);
    box-shadow: 0 0 8px rgba(255, 172, 0, 1);
  }
`;

const Container = styled(PatientSlotContainer)`
  // animation: 1s ${emphasize} ease-in alternate infinite;
  // animation-delay: 250ms;
  border-color: ${props => props.border};
`;

const useStyles = makeStyles(theme =>
  createStyles({
    chatButton: {
      paddingLeft: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  })
);

const PatientSlot = ({
  caretakerMessage,
  physician,
  procedure,
  patient,
  patientType,
  bed,
  hideBedInfo,
  showPriority,
  priority,
  timeEntered,
  poseRef,
  isFamilyReadyPreOp,
  ready,
  isHoldProcedure,
  isBlockNerve,
  readyForSurgeon,
  readyForOr,
  familyReady,
  frameColor,
  expectedExitTime,
  screenType,
  patientData,
  showPreOpNote,
  preOpNote,
  showPacuNote,
  pacuNote,
  showPatientNote,
  patientNote,
  hideChart,
  isDPU,
  showRoom,
  blockNerveFollow,
  called,
  transferredToChair,
  transferredToPT,
  ptComplete,
  isPreOp,
  isPacu,
  messagingView,
  readyForAnesthesia,
  isSpinalTimeout,
  showLatePreOpIndicator,
  room,
  isSuperAdmin,
  hospitalId,
  isGroupAdmin,
}) => {
  const classes = useStyles();
  const isInternalScreen = screenType === INTERNAL_MONITOR;
  const isPreOpScreen = screenType === PREP_TABLET;
  const isPacuScreen = screenType === PACU_TABLET;
  const isPostOpScreen = screenType === POST_OP_TABLET;
  const showChatIcon =
    messagingView &&
    !!patientData?.notificationNumbers &&
    !!patientData?.caretakerConsent &&
    (isInternalScreen || isPacuScreen || isPreOpScreen || isPostOpScreen);

  const isDelayed = useIsDelayed(isPreOp, patientData?.procedure?.startTime || patientData?.procedureData?.startTime);
  const isPacuLate = useIsPacuLate(patientData);

  return (
    <Container
      ref={poseRef}
      messagingView={messagingView}
      border={(ready || isFamilyReadyPreOp) && !isDPU ? '#00B63E' : frameColor}
    >
      <PatientInfo
        physician={physician}
        patient={patient}
        procedure={procedure}
        timeEntered={timeEntered}
        patientType={patientType}
        status={'alert'}
        ready={ready}
        readyForSurgeon={readyForSurgeon}
        readyForOr={readyForOr}
        familyReady={familyReady}
        isHoldProcedure={isHoldProcedure}
        isBlockNerve={isBlockNerve}
        expectedExitTime={expectedExitTime}
        bed={bed}
        showPreOpNote={showPreOpNote}
        showPacuNote={showPacuNote}
        showPatientNote={showPatientNote}
        preOpNote={preOpNote}
        pacuNote={pacuNote}
        patientNote={patientNote}
        hideChart={hideChart}
        isDPU={isDPU}
        showRoom={showRoom}
        blockNerveFollow={blockNerveFollow}
        called={called}
        transferredToChair={transferredToChair}
        transferredToPT={transferredToPT}
        ptComplete={ptComplete}
        isPreOp={isPreOp}
        isPacu={isPacu}
        messagingView={messagingView}
        patientData={patientData}
        patientId={patientData?.id}
        readyForAnesthesia={readyForAnesthesia}
        isSpinalTimeout={isSpinalTimeout}
        room={room}
        showLatePreOpIndicator={isDelayed && showLatePreOpIndicator}
        showPacuLateIndicator={isPacuLate}
        isSuperAdmin={isSuperAdmin}
        hospitalId={hospitalId}
        isGroupAdmin={isGroupAdmin}
      />
      {isInternalScreen && !!caretakerMessage && !messagingView && (
        <CaretakerMessage phoneNumber={caretakerMessage?.phoneNumber} message={caretakerMessage?.content} />
      )}
      {!hideBedInfo && <BedInfo bed={bed} showPriority={showPriority} priority={priority} />}
    </Container>
  );
};

export default PatientSlot;
